<template>
  <Layout :class="[prefixCls,'defaultFrame',getShowTabs?'showTabsBody':'']" v-bind="lockEvents">
    <LayoutFeatures />
    <LayoutHeader  :settingLayout="settingLayout" fixed v-if="getShowFullHeaderRef&&singlePageFlag!==true" />
    <Layout :class="[layoutClass]">
      <LayoutSideBar v-if="singlePageFlag!==true&&(getShowSidebar || getIsMobile)" />
      <Layout :class="`${prefixCls}-main`">
        <LayoutMultipleHeader :appLogoFlag="appLogoFlag" v-if="singlePageFlag!==true" :settingLayout="settingLayout" />
        <LayoutContent :analysisSet="analysisSet" />
        <LayoutFooter />
      </Layout>
    </Layout>
  </Layout>
</template>

<script lang="ts">
import {defineComponent, computed, unref} from 'vue';
  import { Layout } from 'ant-design-vue';
  import { createAsyncComponent } from '@/utils/factory/createAsyncComponent';

  import LayoutHeader from '../../default/header/index.vue';
  import LayoutContent from '../../default/content/index.vue';
  import LayoutSideBar from '../../default/sider/index.vue';
  import LayoutMultipleHeader from '../../default/header/MultipleHeader.vue';

  import { useHeaderSetting } from '@/hooks/setting/useHeaderSetting';
  import { useMenuSetting } from '@/hooks/setting/useMenuSetting';
  import { useDesign } from '@/hooks/web/useDesign';
  import { useLockPage } from '@/hooks/web/useLockPage';

  import { useAppInject } from '@/hooks/web/useAppInject';
  import {usePageFlush} from "@/hooks/setting/usePageFlush";
import {useMultipleTabSetting} from "@/hooks/setting/useMultipleTabSetting";

export default defineComponent({
    name: 'defaultFrame',
    components: {
      LayoutFeatures: createAsyncComponent(() => import('@/layouts/default/feature/index.vue')),
      LayoutFooter: createAsyncComponent(() => import('@/layouts/default/footer/index.vue')),
      LayoutHeader,
      LayoutContent,
      LayoutSideBar,
      LayoutMultipleHeader,
      Layout,
    },
  props:{
    analysisSet:{},
    singlePageFlag:{},
    appLogoFlag:{
      type:Boolean,
      default:false
    },
    settingLayout:{}
  },
    setup(props) {
      const { prefixCls } = useDesign('default-layout');
      const { getIsMobile } = useAppInject();
      const { getShowFullHeaderRef } = useHeaderSetting();
      const { getShowSidebar, getIsMixSidebar, getShowMenu } = useMenuSetting();
      //刷新界面的hook
      usePageFlush();
      // Create a lock screen monitor
      const lockEvents = useLockPage();

      const layoutClass = computed(() => {
        let cls: string[] = ['ant-layout'];
        if (unref(getIsMixSidebar) || unref(getShowMenu)) {
          cls.push('ant-layout-has-sider');
        }
        return cls;
      });

      onMounted(()=>{
        const oldClassName=document.body.className;
        if(!((oldClassName+'').indexOf('defaultFrame-body')>=0)){
          document.body.className=document.body.className+" defaultFrame-body";
        }
      })
      const { getShowMultipleTab } = useMultipleTabSetting();
      const getShowTabs = computed(() => {
        return unref(getShowMultipleTab);
      });
      return {
        getShowTabs,
        singlePageFlag:unref(props).singlePageFlag,
        appLogoFlag:unref(props).appLogoFlag,
        getShowFullHeaderRef,
        getShowSidebar,
        prefixCls,
        getIsMobile,
        getIsMixSidebar,
        layoutClass,
        lockEvents,
      };
    },
  });

</script>
<style lang="less">
.xmDefaultFrame .showTabsBody{
  .MultipleHeader{
    min-height:92px;
  }
}
.analysisSet{
  .vben-layout-mix-sider-menu-list{
    position: absolute !important;
  }
}
.xmDefaultFrame.defaultFrame-body{
  #main_router_view_running{
    .vben-layout-mix-sider{
      .vben-app-logo{
        padding-left: 20px !important;
        img {
          margin-right: 12px !important;
        }
      }
    }
  }
  .mini{
    .vben-app-logo{
      padding-left: 8px !important;
    }
  }
}
  @prefix-cls: ~'@{namespace}-default-layout';

  .@{prefix-cls} {
    display: flex;
    width: 100%;
    min-height: 100%;
    background-color: @content-bg;
    flex-direction: column;

    > .ant-layout {
      min-height: 100%;
    }

    &-main {
      width: 100%;
      margin-left: 1px;
    }
  }
</style>
